import { IRoute } from "src/pages/Router/routes";
import { DocumentPageType } from "src/library/utils/documents/getWebDomainDocument";

import ForgotPasswordPage from "./ForgotPasswordPage";
import GenericError from "./GenericError";
import LoginPage from "./LoginPage";
import NotFound from "./NotFound";
import LogoutPage from "./LogoutPage";
import MaintenanceMode from "./MaintenanceModePage";
import NoAccess from "./NoAccess";
import SuspendedPage from "./SuspendedPage";
import RegistrationPage from "./RegistrationPage";
import CompletingSocialLoginPage from "./CompletingSocialLoginPage";
import DocumentPage from "./DocumentPage";

export const PublicRoutes: IRoute[] = [
  {
    exact: true,
    path: "/",
    pageComponent: LoginPage,
    title: "Login",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/oauth",
    pageComponent: CompletingSocialLoginPage,
    title: "Oauth",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/logout",
    pageComponent: LogoutPage,
    title: "Logout",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/forgot-password",
    pageComponent: ForgotPasswordPage,
    title: "Forgot Password",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/error",
    pageComponent: GenericError,
    title: "Something went wrong",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/404",
    pageComponent: NotFound,
    title: "Not Found",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/403",
    pageComponent: NoAccess,
    title: "Forbidden",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/maintenance",
    pageComponent: MaintenanceMode,
    title: "System in maintenance",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/suspended",
    pageComponent: SuspendedPage,
    title: "Account Suspended",
    menuType: "NONE"
  },
  {
    exact: true,
    path: "/register",
    pageComponent: RegistrationPage,
    title: "Register",
    menuType: "NONE",
    canView: store => !!store.global.settings?.allowPendingCustomers
  },
  {
    exact: true,
    path: `/${DocumentPageType.TermsAndConditions}`,
    pageComponent: DocumentPage,
    title: "Terms & Conditions",
    menuType: "NONE"
  },
  {
    exact: true,
    path: `/${DocumentPageType.PrivacyPolicy}`,
    pageComponent: DocumentPage,
    title: "Privacy Policy",
    menuType: "NONE"
  }
];
